module.exports = __webpack_public_path__ + "static/img/egg_r_05.abd4b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_05.png
// module id = oO1n
// module chunks = 1